/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'template': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 548.571v256q0 14.858-10.857 25.715t-25.714 10.857-25.715-10.857L367.43 748 177.714 937.714q-5.714 5.715-13.143 5.715t-13.142-5.715l-65.143-65.143q-5.715-5.714-5.715-13.142t5.715-13.143L276 656.57l-82.286-82.285q-10.857-10.857-10.857-25.715t10.857-25.714T219.43 512h256q14.857 0 25.714 10.857T512 548.571zm431.429-384q0 7.429-5.715 13.143L748 367.43l82.286 82.285q10.857 10.857 10.857 25.715t-10.857 25.714T804.57 512h-256q-14.857 0-25.714-10.857T512 475.429v-256q0-14.858 10.857-25.715t25.714-10.857 25.715 10.857L656.57 276 846.286 86.286Q852 80.57 859.429 80.57t13.142 5.715l65.143 65.143q5.715 5.714 5.715 13.142z"/>'
  }
})
